import { equals } from 'ramda';

import { type ILocation, type NonEmptyArray } from '../types';

export function needClearGeo(
  nextLocations: NonEmptyArray<ILocation>,
  prevLocations: NonEmptyArray<ILocation>,
): boolean {
  // Если выбрана та же локация
  if (equals(nextLocations.map(n => n.id).sort(), prevLocations.map(n => n.id).sort())) {
    return false;
  }

  // Если следующая локация является группой и содержит предыдущую
  if (
    prevLocations.length === 1 &&
    nextLocations.length > 1 &&
    nextLocations.some(next => prevLocations[0].id === next.id)
  ) {
    return false;
  }

  // Если следующая локация является родительской для текущей
  if (nextLocations.some(next => prevLocations.some(current => current.parentId === next.id))) {
    return false;
  }

  return true;
}
